var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhoneIcon = function SvgPhoneIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.12 14.4958L15.7916 14.23C15.2325 14.1658 14.6825 14.3583 14.2883 14.7525L12.6016 16.4392C10.0075 15.1192 7.8808 13.0017 6.5608 10.3983L8.25664 8.7025C8.6508 8.30833 8.8433 7.75833 8.77914 7.19916L8.5133 4.88916C8.4033 3.96333 7.62414 3.26666 6.68914 3.26666H5.1033C4.06747 3.26666 3.2058 4.12833 3.26997 5.16416C3.7558 12.9925 10.0166 19.2442 17.8358 19.73C18.8716 19.7942 19.7333 18.9325 19.7333 17.8967V16.3108C19.7425 15.385 19.0458 14.6058 18.12 14.4958Z",
    fill: "#2E0DA6"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "phone-icon.3df35a072738b3cf03afa3139cf671cb.svg";